import React, { useState, useContext, useEffect } from "react";
import { MultiSelect } from "react-multi-select-component";
import styles from "./DetallePreguntaReemplazo.module.css";
import DOMPurify from "dompurify";
import GeneralContext from "../../context/GeneralContext";
import * as GeneralActions from "../../store/actions/generalActions";
import * as Funciones from "../../utils/funciones";
import * as Constantes from "../../utils/constantes";
import * as SolicitudRepository from "../../services/repositories/solicitud-repository";
import Modal from "../Modals/Modal";

const DetallePreguntaReemplazo = ({indice, detalleReemplazo, listaSolicitudes, state, setState }) => {
    const { state: generalState, dispatch: generalDispatch } = useContext(GeneralContext)
    let user = generalState.users.filter(userAux => userAux.isAuthenticated)[0]
    let prospecto = user.listaProspectos.filter(prospectoAux => prospectoAux.isSelected)[0]
    let cotizacion = prospecto.cotizaciones.filter(cotizacionAux => cotizacionAux.isSelected || cotizacionAux.completado)[0]
    
    // Verificar si algún producto tiene código 176, 177 o 178
    const hasSpecialProduct = cotizacion.productos && cotizacion.productos.some(prod => 
        Constantes.SPECIAL_PRODUCT_CODES.includes(prod.codigoProducto)
    )

    // Abstraer validaciones repetidas
    const hasDetalleReemplazo = !!detalleReemplazo
    const hasIdSolicitud = hasDetalleReemplazo && detalleReemplazo.idSolicitud !== null
    const isReplacementSelected = hasDetalleReemplazo && detalleReemplazo.flagReemplazoTraspaso === 1
    const isTransferFlagSelected = hasDetalleReemplazo && detalleReemplazo.flagReemplazoTraspaso === Constantes.TRANSFER_TYPE_TRASPASO
    const isTransferOption1 = hasDetalleReemplazo && detalleReemplazo.tipoTraspaso === Constantes.TRANSFER_OPTION_1
    const isTransferOption2 = hasDetalleReemplazo && detalleReemplazo.tipoTraspaso === Constantes.TRANSFER_OPTION_2
    const hasPolicies = hasDetalleReemplazo && detalleReemplazo.polizas !== undefined

    const [mostrarModal, setModal] = useState(false)
    const [textos, setTextos] = useState([])

    const onChangeOpcion = (campo, valor) => {
        generalDispatch(GeneralActions.updateDetalleReemplazoField(campo, Funciones.obtenerValor(valor, Constantes.TIPO_DATO_NUMERICO), indice))
    }

    const onChangeSolicitudes = (valores) => {
        if (cotizacion.listaDetalleReemplazo.length > 1) {
            if (valores.length !== 0) {
                let totalPolizas = cotizacion.listaDetalleReemplazo.find(det => det.idSolicitud !== detalleReemplazo.idSolicitud).polizas
                if (totalPolizas !== undefined) {
                    let pasar = false
                    totalPolizas.map(poliza => {
                        valores.map(valor => {
                            if (poliza.value === valor.value) {
                                setTextos(['Importante', 'Esta póliza ya no puede ser utilizada.'])
                                setModal(true)
                                pasar = false
                            } else {
                                pasar = true
                            }
                            return valor
                        })
                        return poliza
                    })
                    if (pasar) generalDispatch(GeneralActions.updateDetalleReemplazoField('polizas', valores, indice))
                } else {
                    if (valores.length === state.listaPolizas.length) {
                        generalDispatch(GeneralActions.deleteDetalleReemplazo(detalleReemplazo.idSolicitud))
                        setState((state) => {
                            return {
                                ...state,
                                igualNroPol: false
                            }
                        })
                    }
                    generalDispatch(GeneralActions.updateDetalleReemplazoField('polizas', valores, indice))
                }
            } else {
                generalDispatch(GeneralActions.updateDetalleReemplazoField('polizas', valores, indice))
            }
        } else {
            generalDispatch(GeneralActions.updateDetalleReemplazoField('polizas', valores, indice))
            if (valores.length === state.listaPolizas.length && state.listaSolicitudes.length > 1) {
                setState((state) => {
                    return {
                        ...state,
                        igualNroPol: false
                    }
                })
            } else {
                setState((state) => {
                    return {
                        ...state,
                        igualNroPol: true
                    }
                })
            }
        }
    }

    const onChangeCampoDetalleReemplazo = (campo, tipo, valor) => {
        if (campo === 'idSolicitud' && parseInt(valor) !== -1) {
            if (cotizacion.listaDetalleReemplazo !== undefined) {
                let selected = cotizacion.listaDetalleReemplazo.find(l => l.idSolicitud === parseInt(valor))
                if (selected !== undefined) {
                    setTextos(['¡Alerta!', 'Debe seleccionar otra solicitud.'])
                    setModal(true)
                } else {
                    generalDispatch(GeneralActions.updateDetalleReemplazoField(campo, Funciones.obtenerValor(valor, tipo), indice))
                    let tipoProducto = listaSolicitudes.find(sol => sol.idSolicitud === parseInt(valor)).tipoProducto
                    if (tipoProducto !== Constantes.COD_TIPO_PRODUCTO_VIDA_INVERSION) {
                        listarPolizas(1)
                        generalDispatch(GeneralActions.updateDetalleReemplazoField('flagReemplazoTraspaso', 1, indice))
                    }
                    generalDispatch(GeneralActions.updateDetalleReemplazoField('tipoProd', Funciones.obtenerValor(tipoProducto, tipo), indice))
                }
            } else {
                generalDispatch(GeneralActions.updateDetalleReemplazoField(campo, Funciones.obtenerValor(valor, tipo), indice))
                let tipoProducto = listaSolicitudes.find(sol => sol.idSolicitud === parseInt(valor)).tipoProducto
                if (tipoProducto !== Constantes.COD_TIPO_PRODUCTO_VIDA_INVERSION) {
                    listarPolizas(1)
                    generalDispatch(GeneralActions.updateDetalleReemplazoField('flagReemplazoTraspaso', 1, indice))
                }
                generalDispatch(GeneralActions.updateDetalleReemplazoField('tipoProd', Funciones.obtenerValor(tipoProducto, tipo), indice))
            } 
        }
        if (campo === 'flagReemplazoTraspaso') {
            generalDispatch(GeneralActions.updateDetalleReemplazoField(campo, Funciones.obtenerValor(valor, tipo), indice))
            listarPolizas(valor)
            generalDispatch(GeneralActions.updateDetalleReemplazoField('polizas', [], indice))

            const isTransferSelected = parseInt(valor) === Constantes.TRANSFER_TYPE_TRASPASO
            if (!hasSpecialProduct || !isTransferSelected) {
                generalDispatch(GeneralActions.updateDetalleReemplazoField('tipoTraspaso', null, indice))
                return
            }

            generalDispatch(GeneralActions.updateDetalleReemplazoField('tipoTraspaso', Constantes.TRANSFER_OPTION_2, indice))
        } 
    }

    const listarPolizas = async (tipo) => {
        generalDispatch(GeneralActions.updateEstadoCargando(true))
        let response = await SolicitudRepository.obtenerPolizas(cotizacion.asegurado.tipoDocumento.descripcion, cotizacion.asegurado.numeroDocumento, tipo)
        if(response.error === null) {
            setState((state) => {
                return {
                    ...state,
                    listaPolizas: response.polizas
                }
            })
            generalDispatch(GeneralActions.updateEstadoCargando(false))
        } else {
            generalDispatch(GeneralActions.updateError(response.error))
        }
    }

    useEffect(() => {
        if (state.listaPolizas.length === 0 && detalleReemplazo !== null && 
            detalleReemplazo.flagReemplazoTraspaso !== undefined && state.tieneRT) {
            listarPolizas(detalleReemplazo.flagReemplazoTraspaso)
        }
    }, [])

    useEffect(() => {
        if (!hasSpecialProduct || !hasIdSolicitud || !hasDetalleReemplazo || detalleReemplazo.tipoProd !== Constantes.COD_TIPO_PRODUCTO_VIDA_INVERSION) return
        if (detalleReemplazo.flagReemplazoTraspaso !== Constantes.TRANSFER_TYPE_TRASPASO
            || detalleReemplazo.tipoTraspaso !== Constantes.TRANSFER_OPTION_2) {
            generalDispatch(GeneralActions.updateDetalleReemplazoField('flagReemplazoTraspaso', Constantes.TRANSFER_TYPE_TRASPASO, indice))
            generalDispatch(GeneralActions.updateDetalleReemplazoField('tipoTraspaso', Constantes.TRANSFER_OPTION_2, indice))
            listarPolizas(Constantes.TRANSFER_TYPE_TRASPASO)
        }
    }, [hasSpecialProduct, hasIdSolicitud, hasDetalleReemplazo, detalleReemplazo?.tipoProd, detalleReemplazo?.flagReemplazoTraspaso, detalleReemplazo?.tipoTraspaso])


    return (
        <div className={styles.contenedor}>
            <Modal mostrarModal={mostrarModal} setModal={setModal} textos={textos}/>
            <div className={styles.detalle}>
                <div className={styles.solicitud}>
                    <label>Solicitud</label>
                    <select
                        value={hasIdSolicitud ? detalleReemplazo.idSolicitud : -1}
                        onChange={(e) => onChangeCampoDetalleReemplazo('idSolicitud', Constantes.TIPO_DATO_NUMERICO, e.target.value, true)}
                        disabled={hasIdSolicitud && listaSolicitudes.length === 1}
                    >
                        <option value={-1}>Seleccione</option>
                        {listaSolicitudes !== null
                            ? listaSolicitudes.map(solicitud => (
                                <option key={'opcion_' + solicitud.idSolicitud} value={solicitud.idSolicitud}>
                                    {solicitud.descripcion}
                                </option>
                            ))
                            : null
                        }
                    </select>
                </div>
            </div>
            {hasIdSolicitud && (
                <React.Fragment>
                    {detalleReemplazo.tipoProd === Constantes.COD_TIPO_PRODUCTO_VIDA_INVERSION ? (
                        <div>
                            <div className={styles.opciones}>
                                {hasSpecialProduct && (
                                    <label className={styles.opcion}>
                                        <input
                                            type='radio'
                                            value={Constantes.TRANSFER_TYPE_TRASPASO}
                                            checked
                                            readOnly
                                            disabled
                                        />
                                        <p>Traspaso</p>
                                    </label>
                                )}
                                {!hasSpecialProduct && (
                                    <>
                                        <label className={styles.opcion}>
                                            <input
                                                type='radio'
                                                value={1}
                                                selected={isReplacementSelected}
                                                checked={isReplacementSelected}
                                                onChange={(e) => onChangeCampoDetalleReemplazo('flagReemplazoTraspaso', Constantes.TIPO_DATO_NUMERICO, e.target.value, false)}
                                                disabled={cotizacion.edicionInhabilitada}
                                            />
                                            <p>Reemplazo</p>
                                        </label>
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        <label className={styles.opcion}>
                                            <input
                                                type='radio'
                                                value={Constantes.TRANSFER_TYPE_TRASPASO}
                                                selected={isTransferFlagSelected}
                                                checked={isTransferFlagSelected}
                                                onChange={(e) => onChangeCampoDetalleReemplazo('flagReemplazoTraspaso', Constantes.TIPO_DATO_NUMERICO, e.target.value, false)}
                                                disabled={cotizacion.edicionInhabilitada}
                                            />
                                            <p>Traspaso</p>
                                        </label>
                                    </>
                                )}
                            </div>

                            <div className={styles.detalle}>
                                <div className={styles.solicitud}>
                                    <label>Póliza</label>
                                    <MultiSelect
                                        className={`${styles.multi_select_font} ${styles.multi_select_contenedor} ${styles.multi_select}`}
                                        options={state.listaPolizas
                                            .map(solicitud => ({label: (solicitud.numeroPoliza + ' - ' + solicitud.descripcionProducto), value: solicitud.numeroPoliza}))}
                                        hasSelectAll={false}
                                        disableSearch={true}
                                        closeOnChangedValue={false}
                                        value={hasPolicies ? detalleReemplazo.polizas : []}
                                        onChange={onChangeSolicitudes}
                                        overrideStrings={{
                                            "selectSomeItems" : "Seleccione opciones",
                                            "allItemsAreSelected": "Todos las opciones seleccionadas.",
                                            "selectAll": "Select All",
                                            "search": "Search"
                                        }}
                                        disabled={cotizacion.edicionInhabilitada}
                                    />
                                </div>
                            </div>

                            {detalleReemplazo.flagReemplazoTraspaso === Constantes.TRANSFER_TYPE_TRASPASO && (
                                <React.Fragment>
                                    {hasSpecialProduct && (
                                        <React.Fragment>
                                            <div className={styles.opciones}>
                                                <label className={styles.opcion}>
                                                    <input
                                                        type='radio'
                                                        value={1}
                                                        selected
                                                        checked
                                                        disabled
                                                    />
                                                    <p>Opción 1</p>
                                                </label>
                                            </div>
                                            <div className={styles.detalle_texto}>
                                                <div className={styles.texto}>
                                                    <label>OPCIÓN 1: Rescatar y considerar la suma de los saldos de la cuenta individual y de la cuenta de excedentes de la PÓLIZA POR REEMPLAZAR, aplicando el cargo por rescate (si hubiera), y APLICAR el valor de rescate de la PÓLIZA POR REEMPLAZAR como el pago inicial de la prima única que da origen a la PÓLIZA REEMPLAZANTE.</label>
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    )}
                                    {!hasSpecialProduct && (
                                        <React.Fragment>
                                            <div className={styles.opciones}>
                                                <label className={styles.opcion}>
                                                    <input
                                                        type='radio'
                                                        value={1}
                                                        selected={isTransferOption1}
                                                        checked={isTransferOption1}
                                                        onChange={(e) => onChangeOpcion('tipoTraspaso', e.target.value)}
                                                        disabled={cotizacion.edicionInhabilitada}
                                                    />
                                                    <p>Opción 1</p>
                                                </label>
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                <label className={styles.opcion}>
                                                    <input
                                                        type='radio'
                                                        value={Constantes.TRANSFER_OPTION_2}
                                                        selected={isTransferOption2}
                                                        checked={isTransferOption2}
                                                        onChange={(e) => onChangeOpcion('tipoTraspaso', e.target.value)}
                                                        disabled={cotizacion.edicionInhabilitada}
                                                    />
                                                    <p>Opción 2</p>
                                                </label>
                                            </div>

                                            <div className={styles.detalle_texto}>
                                                <div className={styles.texto}>
                                                    <label dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(
                                                        Funciones.obtenerValorTablaMaestra(generalState.tablasMaestras, Constantes.COD_TABLA_MAESTRA_OPCIONES_TRASPASO, '1')
                                                    )}} />
                                                    <label dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(
                                                        Funciones.obtenerValorTablaMaestra(generalState.tablasMaestras, Constantes.COD_TABLA_MAESTRA_OPCIONES_TRASPASO, '2')
                                                    )}} />
                                                </div>

                                                <div className={styles.texto}>
                                                    <label dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(
                                                        Funciones.obtenerValorTablaMaestra(generalState.tablasMaestras, Constantes.COD_TABLA_MAESTRA_OPCIONES_TRASPASO, '3')
                                                    )}} />
                                                    <label dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(
                                                        Funciones.obtenerValorTablaMaestra(generalState.tablasMaestras, Constantes.COD_TABLA_MAESTRA_OPCIONES_TRASPASO, '4')
                                                    )}} />
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    )}
                                </React.Fragment>
                            )}
                        </div>
                    ) : (
                        <div className={styles.detalle}>
                            <div className={styles.solicitud}>
                                <label>Reemplaza la(s) póliza(s)</label>
                                <MultiSelect
                                    className={`${styles.multi_select_font} ${styles.multi_select_contenedor} ${styles.multi_select}`}
                                    options={state.listaPolizas
                                        .map(solicitud => ({label: (solicitud.numeroPoliza + ' - ' + solicitud.descripcionProducto), value: solicitud.numeroPoliza}))}
                                    hasSelectAll={false}
                                    disableSearch={true}
                                    closeOnChangedValue={false}
                                    value={hasPolicies ? detalleReemplazo.polizas : []}
                                    onChange={onChangeSolicitudes}
                                    overrideStrings={{
                                        "selectSomeItems" : "Seleccione opciones",
                                        "allItemsAreSelected": "Todos las opciones seleccionadas.",
                                        "selectAll": "Select All",
                                        "search": "Search"
                                    }}
                                    disabled={cotizacion.edicionInhabilitada}
                                />
                            </div>
                        </div>
                    )}
                </React.Fragment>
            )}
        </div>
    )
}

export default DetallePreguntaReemplazo;